import {Injectable, resource, Resource} from '@angular/core';
import {ConfigurationResponse} from '@backend';
import {LandingServiceBrokerService} from '@services/landing-service-broker/landing-service-broker.service';
import {lastValueFrom} from 'rxjs';

@Injectable({providedIn: 'root'})
export class LandingServiceConfigService {
  private static readonly _valueCache: Record<string, ConfigurationResponse> = {};
  private static readonly _resourceCache: Record<string, Resource<ConfigurationResponse>> = {};

  constructor(private readonly lsbs: LandingServiceBrokerService) {}

  async getPromise(organization?: string) {
    if (organization === undefined) return undefined;
    if (LandingServiceConfigService._valueCache[organization])
      return LandingServiceConfigService._valueCache[organization];

    const services = await this.lsbs.getByOrganizationName(organization);
    const value = await lastValueFrom(services.StatusService.getConfigurations({observe: 'body'}));
    return (LandingServiceConfigService._valueCache[organization] = value);
  }

  getResource(organization: string | (() => string)) {
    if (typeof organization === 'function') {
      return resource({
        params: () => ({org: organization()}),
        loader: async ({params}) => this.getPromise(params.org),
      });
    }
    return (LandingServiceConfigService._resourceCache[organization] ??= resource({
      loader: async () => this.getPromise(organization),
    }));
  }
}
